module.exports = __webpack_public_path__ + "img/ctrl-c-stub-mid-+i.49f9b5f4.svg";